// This File contains data for each Exercise and its types:
export const muscles = ["shoulders", "chest", "arms", "back", "legs"];

export const exercises = [
  {
    id: "overhead-press",
    title: "Overhead Press",
    description:
      "The dumbbell overhead press increases strength throughout the shoulders and engages the core for stability.1﻿ It can be done in either a sitting or standing position, and with dumbbells held horizontally at the shoulders or rotated in a hammer grip. A sitting position helps stabilize the back, while a standing position works a wider range of muscles. Beginners should pick a light weight to start, increasing it until you find a weight that you can lift with good form for 10 repetitions but feel fatigued at the final rep. Women might start with 5-pound dumbbells and men with 10-pound dumbbells. You can use this exercise in any upper body strength workout.",
    muscles: "shoulders",
    url:
      "https://image.shutterstock.com/image-vector/overhead-press-top-body-workout-600w-1425852761.jpg"
  },
  {
    id: "dips",
    title: "Dips",
    description:
      "Dips are a compound, body-weight exercise. You do Dips by first raising yourself on two dip bars with straight arms. Lower your body until your shoulders are below your elbows. Push yourself up until your arms are straight again. Dips work your chest, shoulders, back and arm muscles",
    muscles: "arms",
    url:
      "https://image.shutterstock.com/image-vector/woman-doing-triceps-dips-bench-600w-1621991521.jpg"
  },
  {
    id: "barbell-curls",
    title: "Barbell Curls",
    description:
      "The barbell curl is an arm exercise that is also one of the most recognizable movements in all of bodybuilding and fitness. It helps build sleeve-popping biceps and allows heavier loading than many other curl variations. It is usually performed in moderate to high reps, such as 8-12 reps per set, as part of the arm-focused portion of any workout.",
    muscles: "arms",
    url:
      "https://image.shutterstock.com/image-vector/two-fitness-women-lifting-weight-600w-1771472165.jpg"
  },
  {
    id: "bench-press",
    title: "Bench Press",
    description:
      "The bench press is a compound exercise that involves the pectoralis major of the chest, the anterior deltoids of the shoulder, and the triceps brachii of the upper arm. It builds strength as well as encourages the growth of these muscles. Muscle growth is not only desired by bodybuilders, but also for anybody over age 40 when age-related muscle loss is a concern.1﻿ It is a functional exercise that helps you with any daily activities that require pushing or carrying. The bench press can help restore muscle balance for athletes that primarily use pulling muscles, such as in wrestling, rock climbing, and swimming. The barbell bench press is a competitive lift in the sport of powerlifting, with the other two being the deadlift and squat. If you're training for competition powerlifting, you should contact a professional coach for personal instruction.",
    muscles: "chest",
    url:
      "https://image.shutterstock.com/image-vector/bench-press-exercise-bearded-man-260nw-378852940.jpg"
  },
  {
    id: "pull-ups",
    title: "Pull Ups",
    description:
      'Pull-ups can be done with a supinated, neutral, or pronated grip (often called "chin-ups", "hammer grip pull-ups", and "pull-ups", respectively). Grips may match each other or be different (mixed grip). Grips may also rotate throughout the movement, such as by doing them on rings, rotating handles (false grip) or pull up handles. The range of motion used by trainers can vary. The fullest possible range is with straight arms overhead (elbow directly above shoulder), to pulling when the arms are at the sides (elbow directly below shoulder). People sometimes only train portions, such as avoiding locking out the arms at the bottom, or stopping when the head/chin/neck touch the bar. Positions within the range are also trained isometrically, as in flexed-arm and straight-arm hangs for time.',
    muscles: "back",
    url:
      "https://image.shutterstock.com/image-vector/man-doing-pullups-vector-silhouette-260nw-196646405.jpg"
  },
  {
    id: "deadlifts",
    title: "Deadlifts",
    description:
      'The barbell deadlift is a compound exercise used to develop overall strength and size in the posterior chain. It is a competition lift in the sport of powerlifting, but is also considered a classic benchmark of overall strength. When performed with the hands outside the knees, it is often called a "conventional" deadlift. When the feet are wide and the hands are inside the knees, it is a sumo deadlift.',
    muscles: "back",
    url:
      "https://image.shutterstock.com/image-vector/strong-man-athlete-doing-deadlift-260nw-1198034095.jpg"
  },
  {
    id: "squats",
    title: "Squats",
    description:
      "A squat is a strength exercise in which the trainee lowers their hips from a standing position and then stands back up. During the descent of a squat, the hip and knee joints flex while the ankle joint dorsiflexes; conversely the hip and knee joints extend and the ankle joint plantarflexes when standing up.",
    muscles: "legs",
    url:
      "https://image.shutterstock.com/image-vector/man-making-squats-exercise-butt-600w-1348704479.jpg"
  }
];
